/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const customerFeedbackStyle = {
  slide: (theme: Theme) => ({
    display: "flex",
    justifyContent: "flex-end",
    padding: "0 1rem",
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "calc(100% / 2)",
    },
    [theme.breakpoints.up("lg")]: {
      width: "calc(100% / 3.125)",
    },
  }),
  slideInner: (theme: Theme) => ({
    backgroundColor: theme.palette.background.light,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    padding: "2rem",
    height: "100%",
    width: "100%",
  }),
  sliderArrowsDesktop: (theme: Theme) => ({
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "flex-end",
      height: "100%",
    },
  }),
  sliderArrowsMobile: (theme: Theme) => ({
    display: "flex",
    justifyContent: "center",
    marginTop: "3rem",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  }),
  seals: (theme: Theme) => ({
    maxWidth: "8rem",
    height: "auto",
    [theme.breakpoints.up("md")]: {
      maxWidth: "12rem",
    },
  }),
};
